import React from "react";
import { attach } from "../../common/componentExtensions";
import { Combo } from "../../common/components/comboBox";
import { Frazione } from "../../generated";
import FrazioniActions from "../FrazioniActions";
import FrazioniStore from "../FrazioniStore";
import { formGroup } from "../../common/components/formGroup";

const Combobox = Combo<Frazione>();
interface Props {
    codFisComune: string;
    data: Frazione[] | null,
    value: Frazione | string | null,
    onChange: (type: Frazione | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
    readonly?: boolean;
}
class __FrazioneSelector extends React.PureComponent<Props>{

    componentDidMount() {
        if (!this.props.data)
            FrazioniActions.search(this.props.codFisComune);
    }
    componentDidUpdate(oldProps: Props) {
        if (oldProps.codFisComune != this.props.codFisComune)
            FrazioniActions.search(this.props.codFisComune);
    }

    render() {
        const { data, onChange, value, error, label, onBlur, onFocus, readonly } = this.props;
        const frazione = (data || []).find(frazione => typeof value === "string" ? frazione.codFrazione == value : frazione.codFrazione == value?.codFrazione) ?? null;
        return <Combobox
            label={label ?? "Frazione"}
            allowNull
            data={data || []}
            busy={data == null}
            textField={x => x?.nomeFrazione ?? ""}
            onSelect={x => onChange(x)}
            value={frazione}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
            readonly={readonly}
        />;
    }
}
export const FrazioneSelector = formGroup(attach(__FrazioneSelector, FrazioniStore, (store, props) => ({ data: store.get(props.codFisComune) })))